module.exports = __webpack_public_path__ + "static/media/KFOlCnqEu92Fr1MmSU5fCxc4AMP6lbBP.0aecdf2f.woff2";